export default "assets/images/icons/slider-arrow-a17c6e83.svg";